import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// report-common
import { getReportReducers } from '../../report-common';
// feature carrier-statistic-report
import * as A from './actions';
//////////////////////////////////////////////////

const initial = {
  carrierGuid: null,
};

const {
  setReports,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListSuccess2,
  setTableTitleFilter,
  resetListAndPagination,
} = getReportReducers(initial);

const setCarrierGuid = (state, data) => P.$set('carrierGuid', data, state);

export default createReducer({
  [A.setReports]: setReports,
  [A.setUsedReport]: setUsedReport,
  [A.setCarrierGuid]: setCarrierGuid,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess2,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
}, initialState);
